<div class="progress-bar" [ngClass]="type">
  <ng-content></ng-content>
  <div class="progress-bar__graph">
    <mat-progress-bar mode="determinate" value="{{ getProgress() }}"></mat-progress-bar>
  </div>
</div>
